import { SurveyQuestionSlider } from './SurveyQuestionSlider';

import { SurveyOverviewBuilderQuestion } from '@/pages/Surveys/SurveysOverviewBuilder/types';

import { Step } from '../../Stepper/Stepper';
import { SurveyQuestionSetStepperData, SurveyQuestionStepperData } from '../SurveyQuestionStepper';

export const SurveyQuestionScaleStep = (
  stepperData: SurveyQuestionStepperData,
  setStepperData: SurveyQuestionSetStepperData,
  question: SurveyOverviewBuilderQuestion,
  index: number,
  total: number
) => {
  const handleChange = (value: number[]) => {
    setStepperData(prev => ({ ...prev, scale: value[0] }));
  };

  const step: Step = {
    value: index,
    content: (
      <div className="w-full">
        <div className="flex items-center gap-1.5 mb-5 text-body-14-medium text-custom-warm-grey-400">
          <p>
            Question {index + 1} of {total}
          </p>
          {!question.required && (
            <div className="flex items-center gap-2">
              <span className="size-1 bg-custom-warm-grey-400 inline-block rounded-full" />
              <p>Optional</p>
            </div>
          )}
        </div>
        <h4 className="text-body-24-semibold text-custom-warm-grey-700 mb-[52px]">
          {question.question}
        </h4>
        <div className="mb-4">
          <SurveyQuestionSlider
            value={[stepperData.scale]}
            onValueChange={handleChange}
            min={question.span.from.count}
            max={question.span.to.count}
            step={1}
          />
        </div>
        <div className="flex items-center justify-between text-body-14-regular text-custom-warm-grey-500">
          <p>{question.span.from.text}</p>
          <p>{question.span.to.text}</p>
        </div>
      </div>
    ),
  };

  return step;
};
